import { API_BASE, API_URL } from "@/constants";
import { InventoryResponse } from "@/types/api/inventory";
import { getApiError } from "@/utils/api-error";

export async function fetchInventory() {
  const response = await fetch(`${API_URL}${API_BASE}/inventory`);
  if (!response.ok) {
    throw await getApiError(response);
  }
  return response.json() as Promise<InventoryResponse>;
}
